import * as React from 'react';
import { usePrevious } from '@core-front/helper';
import { getElementFontSize, isElementInline, getParentElementParameters, formatNumberToPixels, } from './helpers';
const FittextCore = (props) => {
    const { className, children, } = props;
    const container = React.useRef(null);
    const [fontSize, setFontSize] = React.useState(0);
    const [parentWidth, setParentWidth] = React.useState(0);
    const prevChildren = usePrevious(children);
    const resizeText = React.useCallback(() => {
        if (!container.current) {
            return;
        }
        const el = container.current;
        const elementFontSize = getElementFontSize(el);
        const width = isElementInline(el) ? el.offsetWidth : el.scrollWidth;
        const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
        if (currentParentWidth && elementFontSize && parentFontSize) {
            const isChildGreaterThanParent = width > (currentParentWidth + 1);
            const isResetRequired = parentWidth !== currentParentWidth;
            setParentWidth(currentParentWidth);
            if (isResetRequired) {
                setFontSize(parentFontSize);
            }
            else if (isChildGreaterThanParent && fontSize > 1) {
                setFontSize((f) => f - 1);
            }
        }
    }, [fontSize, parentWidth]);
    React.useLayoutEffect(() => {
        resizeText();
    }, [fontSize, parentWidth, resizeText]);
    React.useEffect(() => {
        const resizeHandler = () => resizeText();
        window.addEventListener('resize', resizeHandler);
        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [resizeText]);
    /**
     * Update parentWidth and reset fontSize after children text value changes.
     * Explicitly check if children text value has changed,
     * because other parent element changes shouldn't trigger this hook (e.g. EqualHeight)
     */
    React.useEffect(() => {
        // Check if string as child has changed (React provides children always as array)
        if (prevChildren && children[0] !== prevChildren[0]) {
            const el = container.current;
            if (el) {
                const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
                setParentWidth(currentParentWidth);
                setFontSize(parentFontSize);
            }
        }
    }, [children, prevChildren]);
    const BEM = () => {
        const classArray = ['fittext'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("span", { style: { fontSize: fontSize ? formatNumberToPixels(fontSize) : undefined }, ref: container, className: BEM() }, children));
};
export default FittextCore;
